import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SelectItem} from '@tj/tj-dmp-lib-api';
import {AbstractEditorComponent} from '../abstract-editor.component';
import {ValueEditor} from '../value-editor';
import {FormBuilder} from '@angular/forms';
import {ValidatorEditorService} from "../validator-editor.service";

@Component({
    selector: 'dmp-boolean-editor',
    templateUrl: './boolean-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class BooleanEditorComponent extends AbstractEditorComponent implements OnInit {
    items: SelectItem[] = [];

    constructor(protected translate: TranslateService,
                protected fb: FormBuilder,
                protected validatorService: ValidatorEditorService) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return value;
    }

    ngOnInit(): void {
        this.init();
        this.items = [{
            label: this.translate.instant('common.True'),
            value: true
        }, {
            label: this.translate.instant('common.False'),
            value: false
        }];
        this.disable = this.value === 'null';
    }
}
